export interface StorageOptions {
  key: string
  initialValue: any
}

export interface StorageObjectKeyOptions {
  storageKey: string
  keyInObject: string
  initialValue: any
}

export const getLocalStorageValue = <T>(options: StorageOptions): T => {
  try {
    const item = window.localStorage.getItem(options.key)
    return item ? JSON.parse(item) : options.initialValue
  } catch (error) {
    console.warn(`Error reading localStorage key "${options.key}":`, error)
    return options.initialValue
  }
}

export const setLocalStorageValue = <T>(
  options: StorageOptions,
  value: T,
): void => {
  try {
    window.localStorage.setItem(options.key, JSON.stringify(value))
  } catch (error) {
    console.warn(`Error setting localStorage key "${options.key}":`, error)
  }
}

export const getLocalStorageObjectKey = <T>(
  options: StorageObjectKeyOptions,
): T => {
  try {
    const item = window.localStorage.getItem(options.storageKey)
    return item ? JSON.parse(item)[options.keyInObject] : options.initialValue
  } catch (error) {
    console.error('Error getting data from localStorage', error)
    return options.initialValue
  }
}

export const setLocalStorageObjectKey = <T>(
  options: StorageObjectKeyOptions,
  value: T,
): void => {
  try {
    const item = window.localStorage.getItem(options.storageKey)
    const storedObject = item ? JSON.parse(item) : {}
    const newObject = { ...storedObject, [options.keyInObject]: value }
    window.localStorage.setItem(options.storageKey, JSON.stringify(newObject))
  } catch (error) {
    console.error('Error setting data to localStorage', error)
  }
}
